import * as React from 'react';
import { UIState, WellnessTabs } from 'data/UIState';
import { observer } from 'mobx-react';

import './MyWellnessTabBar.pcss';



const MyWellnessTabBar = observer(() =>
  <div className="myWellnessTabBar">
    {UIState.settings.ENABLE_JOURNAL &&  <button onClick={()=> { UIState.wellnessTab = 'journal'; }} className={`${UIState.isJournal?'selected':''}`}><i className="fa fa-pencil-square-o"></i>Journal</button>}
    {UIState.settings.ENABLE_TRACKERS &&  <button onClick={()=> { UIState.wellnessTab = WellnessTabs.TRACKERS; }} className={`${UIState.isTrackers?'selected':''}`}><i className="fa fa-line-chart"></i>Trackers</button>}
    {UIState.settings.ENABLE_GOALS &&  <button onClick={()=> { UIState.wellnessTab = 'goals'; }} className={`${UIState.isGoals?'selected':''}`}><i className="fa fa-check-circle-o"></i>Goals</button>}
    {/*<button onClick={()=> { UIState.wellnessTab = 'profile'; }} className={`${UIState.isProfile?'selected':''}`}><i className="fa fa-user"></i>Profile</button>*/}
  </div>
);

export { MyWellnessTabBar };
